<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-detached">
			<div class="content-body">
				<app-search-bar 
				[criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" 
				[config]="configLocal.barraBusqueda" 
				[nombreCampoDatePicker]="configLocal.barraBusqueda.nombreCampoDatePicker" 
				(busqueda)="searchElementsByFilter($event)" 
				[useAccordionMode]="true" 
				[showRegiones]="true" 
				[showComunas]="true" 
				[filtroImportado]="true" 
				[filtroAnulados]="true" 
				[filtroTercerizadas]="true"
				></app-search-bar>
				<section class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title">
									{{ configLocal.table.title }} - Usted esta operando como: {{ getRutOperando() }}
									{{
										filterDescription
											? " - " + filterDescription
											: ""
									}}
								</h4>
								<div *ngIf="maxBHE > 0" class="card-toolbar">BHEs: {{ cantidadBHE }} |{{ maxBHE }}</div>
							</div>
							<div class="card-head">
								<div class="heading-elements mt-0">
									<button class="buttonMantenedor btn btn-warning float-right mr-5 mt-5 btn-export" data-gtm-id="exportar" data-gtm-group="bhe-emitidos" (click)="exportToExcel()" ngbTooltip="Exporta tus registros filtrados a Excel" *ngIf="permissions.getPermission('80-18').asignado">
										<i class="flaticon-download-1"></i>
										Exportar Excel
									</button>
									<button class="buttonMantenedor btn btn-success float-right mr-5 mt-5" data-gtm-id="generar" data-gtm-group="bhe-emitidos" *ngIf="permissions.getPermission('80-16').asignado" (click)="navigateToBheEmisor()">
										<i class="flaticon-add-circular-button"></i>
										<span class="menu-text">Generar Boleta de Honorario</span>
									</button>
								</div>
								<div class="heading-elements mt-0">
									<button id="dropdownConciliacion" class="btn btn-info float-right mr-5 mt-5 buttonMantenedor" data-gtm-id="sincronizar" data-gtm-group="bhe-emitidos" *ngIf="permissions.getPermission('80-20').asignado" (click)="openDatePickerImportedBhe(datePickerImportedBheSiiModal, true)">
										<i class="flaticon-refresh"></i>
										Sincronizar con el Sii
									</button>
								</div>
							</div>
							<div class="card-content">
								<div class="card-body">
									<ngx-datatable
										#table
										class="material mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="70"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[selectionType]="'checkbox'"
										[selected]="selected"
										(selected)="onSelect($event)"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										(sort)="utilities.onSortTable(table, page)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
										[externalSorting]="false"
										[sortType]="SortType.multi">
										<ngx-datatable-column name="folioBhe" [flexGrow]="2" [sortable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Folio</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.folio }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="rutEmisor" [flexGrow]="2" [sortable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'" [resizeable]="false" *ngIf="mostrarRutEmisor">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Rut Emisor</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.rutEmisor }}-{{ row.dvEmisor }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="rutReceptor" [flexGrow]="2" [sortable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Rut Receptor</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.rutReceptor }}-{{ row.dvReceptor }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="nombreReceptor" [flexGrow]="6" [sortable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Nombre Receptor</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.nombreReceptor }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="fechaEmision" [flexGrow]="2" [sortable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Fecha Emisión</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.fechaEmision | date : "dd/MM/yyyy" }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="total" [flexGrow]="3" [sortable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment">Total</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment">{{ row.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Acciones" [flexGrow]="5" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a [routerLink]="" title="Descarga PDF" ngbTooltip="Descarga PDF" class="success edit mr-1 mrless" (click)="downloadPDF(row)" *ngIf="permissions.getPermission('80-10').asignado">
													<div class="icon-circle bg-danger text-center align-middle pt-file-button">
														<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
                                                                                                <a [routerLink]="" title="Envío Correo" ngbTooltip="Envío Correo" class="success edit mr-1 mrless" (click)="openEnvioCorreoModal(correoModal, row)" *ngIf="permissions.getPermission('80-12').asignado">
													<div class="icon-circle bg-primary text-center align-middle pt-file-button">
														<fa-icon icon="envelope" class="fa-lg text-white"></fa-icon>
													</div>
												</a>

												<a [routerLink]="" ngbTooltip="Anular Boleta de Honorarios" *ngIf="!row.anulada && permissions.getPermission('80-14').asignado && !row.terceros" class="danger edit mr-1 mrless" (click)="openAnularBheModal(anularBheModal, row)">
													<div class="icon-circle bg-warning text-center align-middle pt-null-button">
														<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<span class="badge badge-warning imported-badge font-italic mr-1" *ngIf="row.terceros">{{row.nombrePersonaAutorizada}}</span>
												<span class="badge badge-light imported-badge font-italic mr-1" *ngIf="row.importada">Import.</span>
												<span class="badge badge-danger imported-badge font-italic" *ngIf="row.anulada">Nula</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-2 pl-0">Elementos por página</div>
												<div>
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-2 pl-1 pr-0 col-3 divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="table.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>

<ng-template #anularBheModal let-d="dismiss" let-c="close">
	<div class="modal-content">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Anulación de Boleta de Honorarios</div>
				<div class="modal-wizard-desc">Indique el motivo de la anulación de la boleta de honorarios seleccionada</div>
			</div>
		</div>
		<div class="modal-body">
			<app-anulador-bhe [bheEmitida]="selectedBhe" (sendCloseRequestEmitter)="closeAnularBheModal()" (sendNullifyBHERequest)="anularBhe($event)"></app-anulador-bhe>
		</div>
	</div>
</ng-template>

<ng-template #correoModal>
	<div class="modal-content">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Envío de Boletas de Honorarios</div>
				<div class="modal-wizard-desc">Indique la dirección de correo electroniuco para enviar la boleta de honorarios seleccionada</div>
			</div>
		</div>
		<div class="modal-body">
			<app-envio-bhe-correo [emitida]="true" [bheEmitida]="selectedBhe" (sendCloseRequestEmitter)="closeAnularBheModal()" (sendEmailBHERequest)="sendCorreo($event)"></app-envio-bhe-correo>
		</div>
	</div>
</ng-template>

<ng-template #datePickerImportedBheSiiModal let-d="dismiss">
	<div class="modal-content">
		<form (ngSubmit)="importBheSii(request)" #request="ngForm">
			<div class="modal-header">
				<div class="modal-wizard-label">
					<div class="modal-wizard-title">Importación Bhe desde el SII</div>
					<div class="modal-wizard-desc">Indique fecha para lectura de datos en el S.I.I.</div>
				</div>
			</div>
			<div class="modal-body">
				<div class="form-group row mx-auto">
					<div class="col-4 label-control pt-3">Fecha</div>
					<div class="col-8">
						<input type="text" name="dateConciliacion" [maxDate]="todayString" ngxDaterangepickerMd [locale]="locale" (change)="detectChangeDate($event)" (input)="detectChangeDate($event)" [(ngModel)]="dateConciliacion" class="form-control" [singleDatePicker]="true" [autoApply]="true" [autocomplete]="false" [showDropdowns]="true" />
						<div *ngIf="request.submitted && (dateConciliacion.startDate == null || dateConciliacion == '' || !validDate)" class="invalid-feedback-group">
							<div *ngIf="dateConciliacion.startDate == null">Campo requerido</div>
							<div *ngIf="!validDate && locale.format == 'MM/YYYY'">Fecha inválida, use el formato mm/yyyy</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
						<i class="la la-paper-plane-o d-lg-none"></i>
						<span class="d-none d-lg-block">Importar</span>
					</button>
					<button type="button" class="btn btn-secondary ml-3" (click)="d('Cross click')">
						<span class="d-none d-lg-block">Cerrar</span>
					</button>
				</div>
			</div>
		</form>
	</div>
</ng-template>

<swal #currentSwal title="Operación" text="Operación realizada" icon="info"></swal>
